import { H2HType } from "types/business/H2HType";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = H2HType[];

export const useDefaultObservableH2HTypeArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectH2HTypeArray extends BehaviorSubject<CurrentType> {}
